import {ActionCompletionDialogComponent} from '../../common/action-completion-dialog/action-completion-dialog.component';
import {ActivatedRoute, Router} from '@angular/router';
import {CommonService} from '../../services/common.service';
import {Component, OnInit, ViewChild} from '@angular/core';
import {ConfirmationDialogComponent} from '../../repair-details/confirmation-dialog/confirmation-dialog.component';
import {FailuresDialogComponent} from './failures-dialog/failures-dialog.component';
import {MatDialog} from '@angular/material';
import {PurchaseOrdersService} from '../../services/purchase-orders.service';
import {ToastMessagesService} from '../../services/toast-messages.service';
import {MatTableDataSource} from '@angular/material';
import OrderDetailsConfig from '../../table/configs/receiving-order-details.json';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';

@Component({
  styleUrls: ['./receiving-order-details.component.scss'],
  templateUrl: './receiving-order-details.component.html'
})
export class ReceivingOrderDetailsComponent implements OnInit {
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  public dataSource: MatTableDataSource<any>;
  public orderDetails: any;
  orderId: number;
  public orderDetailsConfig: any;
  public basicDetailsConfig: any;
  public showBasicInfo: boolean;
  public statusId: number;
  private parentRowRequest: any;
  public displayedColumns: string[] = ['material_id', 'material_description', 'total_quantity', 'quantity_executed',
    'quantity_left', 'date_completed', 'evaluation_category_name', 'is_led_name'];

  constructor(private activatedRoute: ActivatedRoute,
              private commonService: CommonService,
              private matDialog: MatDialog,
              private purchaseOrdersService: PurchaseOrdersService,
              private router: Router,
              private toastMessagesService: ToastMessagesService) {
    const orderDetails = localStorage.getItem('orderDetails');
    this.orderDetails = orderDetails ? JSON.parse(orderDetails) : {};
    this.statusId = -1;
    this.dataSource = new MatTableDataSource<any>([]);
  }

  public async ngOnInit(): Promise<any> {
    this.activatedRoute.params.subscribe(async (params) => {
      this.orderId = +params.id;
      this.orderDetailsConfig = OrderDetailsConfig;
      this.orderDetailsConfig.filter = `command_id=${params.id}`;
      this.parentRowRequest = await this.commonService.getListWithParameters(`loading_command/web`, `id=${this.orderId} AND command_type = 1`);
      const parentRow = this.parentRowRequest[0][0];
      this.orderDetails.address = parentRow.sale_point_address;
      this.orderDetails.recipient = parentRow.sale_point_name;

      this.showBasicInfo = true;
      await this.initBasicInfo();
      this.statusId = await this.purchaseOrdersService.fetchStatusId(`unloading_command/web/status?id=${params.id}`);
      const order = await this.commonService.getListWithParameters('loading_command/web/details/new', `${this.orderId}`) as any[];
      this.dataSource = new MatTableDataSource<any>(order);
      this.dataSource.paginator = this.commonService.setPaginatorTexts(this.paginator);
      this.dataSource.sort = this.sort;
    });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  private async initBasicInfo() {
    this.showBasicInfo = true;
    this.basicDetailsConfig = {
      subtitle: [
        {
          title: 'Εντολή Παραλαβής',
          value: this.orderId
        }
      ],
      title: 'Πληροφορίες Εντολής Παραλαβής'
    };

    await this.initializeActions();
  }

  private async initializeActions() {
    const actions = [];
    const action1 = {
      function: () => {
        this.initFailuresDialog(this.orderId);
      },
      showAction: this.orderDetails.status !== 1,
      title: 'Ποιοτικές αστοχίες',
      icon: 'assignment',
      color: 'blue'
    };
    const action2 = {
      function: () => {
        this.initializeConfirmCancellationDialog(this.orderDetails);
      },
      showAction: this.canShow(),
      title: 'Διαγραφή Εντολής Παραλαβής',
      icon: 'cancel',
      color: 'red'
    };
    actions.push(action2);
    actions.push(action1);

    if (actions.length > 0) {
      this.basicDetailsConfig.actions = actions;
      this.basicDetailsConfig.showActions = true;
    } else {
      this.basicDetailsConfig.showActions = false;
    }
  }

  initFailuresDialog(id) {
    this.matDialog.open(FailuresDialogComponent, {
      width: '550px',
      data: {
        id
      }
    });
  }

  initializeConfirmCancellationDialog(details) {
    const cancellationDialog = this.matDialog.open(ConfirmationDialogComponent, {
      data: {
        message: `Είστε σίγουροι ότι θέλετε να διαγράψετε την εντολή παραλαβής με αριθμό ${details.order_id}?`,
        title: 'Διαγραφή Εντολής Παραλαβής'
      }
    });

    cancellationDialog.afterClosed().subscribe(async (response) => {
      if (response) {
        await this.cancelRequest(details);
      }
    });
  }

  private async cancelRequest(details) {
    try {
      await this.commonService.deleteItem(`unloading_command/web`, details.order_id);
      this.toastMessagesService.toastMessages('Η διαγραφή ολοκληρώθηκε με επιτυχία');
      await this.router.navigate(['receipt_orders']);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  private canShow() {
    if (this.orderDetails.status === 1 && this.orderDetails.loading_order_id === null) {
      return true;
    }
  }

  public async completeReceiptCommand(): Promise<void> {
    try {
      // tslint:disable-next-line:max-line-length
      await this.purchaseOrdersService.updateReceiptCommand('unloading_command/details/complete', {
        id: this.orderDetails.order_id,
        order_type_id: this.orderDetails.order_type_id,
        order_id: this.orderDetails.order_id1,
        status_id: this.orderDetails.status
      });
      this.matDialog.open(ActionCompletionDialogComponent, {
        data: {
          buttonText: 'Πλοήγηση στις παραλαβές',
          redirectURL: `receipt_orders`
        }
      });
    } catch (e) {
    }
  }

  public navigateToRow(row) {
    this.router.navigate([`receiving_order_details_info/${row.id}`]);
  }

}
